var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":_vm.id,"height":"100px","width":"100px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }